export const FLAP_VAULTS = [
  {
    id: "flap-mint",
    category: "build",
    isNew: true,
    name: "公平 Mint · BNB",
    nameEn: "Fair Mint · BNB",
    summary:
      "先募 BNB（每份固定 0.01，目标 0–16），满额后一笔上蝴蝶发射；可挂税金库。参与者按份手动领币；发射前可退款。仅 BNB。",
    summaryEn:
      "Raise BNB first (0.01 / share, target 0–16), then one-shot Flap launch; optional tax vault. Claim by share; refund before launch. BNB only.",
    factory: "",
    tokenCA: "",
    tokenLabel: "$CA",
    tokenName: "FlapMint",
    tokenSymbol: "MINT",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreie2klmdqwwvownoyuawqgfvh4xywnhgzydx5hrargivdjaod33gtu",
    vaultImage: "/images/minute-buyback-vault.webp",
    flapUrl: "",
    tags: ["公平Mint", "BNB", "按份领币", "可挂金库", "上新"],
    deployNote:
      "流程：创建 Mint 金库 → 用户按份 Mint（0.01 BNB/份）→ 满额一笔发射 → 详情页领币。\n\n目标 0–16 BNB；目标为 0 时跳过 Mint，创建者带首买 BNB 发射。\n\n部署合约后把工厂地址写入 flapMintConfig.js。",
    deployNoteEn:
      "Flow: create Mint vault → mint shares (0.01 BNB each) → one-shot launch → claim on detail.\n\nTarget 0–16 BNB; target 0 skips mint (creator launches with first-buy BNB).\n\nAfter deploy, set factory in flapMintConfig.js.",
  },
  {
    id: "half-perpetual",
    category: "buyback",
    name: "30秒永动回购",
    nameEn: "30s Perpetual Buyback",
    summary:
      "Virus 金库 · 30 秒永动销毁+裂变+二重销毁。税路 99% 回购 / 1% 裂变；单次消耗回购池 50%；冷却约 30 秒。已验证，低风险。",
    summaryEn: "Virus vault · 30s perpetual burn + fission + dual burn. Tax split 99% buyback / 1% fission; each run spends 50% of the buyback pool; ~30s cooldown. Verified, low risk.",
    factory: "0xbb88A8b1BA70e1D72Fc87E6e01f40e92A393dBfC",
    tokenCA: "0xc82d112e7ed62880a310a77a62d5a46740bc7777",
    tokenLabel: "$CA",
    tokenName: "羊帆起航共识群1095998599",
    tokenSymbol: "羊帆起航",
    image: "https://flap.mypinata.cloud/ipfs/bafkreieyvjjqueofmumhtjzkekxy4kqao33gb2ykav2j34mnnyyfq6vkqy",
    vaultImage: "/images/half-perpetual-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xc82d112e7ed62880a310a77a62d5a46740bc7777",
    tags: ["已验证", "低风险", "30秒回购", "Virus金库", "99%回购"],
    deployNote:
      "要填：1 项\n\n① 营销钱包\n填你自己的钱包地址（用来收营销税）。\n不要填全是 0 的空地址。",
    deployNoteEn: "Fill: 1 field\n\n① Marketing wallet\nYour wallet for marketing tax.\nDo not use the zero address.",
  },
  {
    id: "floor-protocol",
    category: "floor",
    name: "动态托底协议",
    nameEn: "Dynamic Floor Protocol",
    summary:
      "蝴蝶暴力动态托底：卖出税进金库，池越深倍率越高（约每 0.5 BNB +1x，封顶 500x）。税路：托底 50% · 分红 35% · 社区 5% · 销毁 9% · 裂变 1%。已验证，低风险。",
    summaryEn: "Aggressive dynamic floor: sell tax feeds the vault; deeper pool = higher multiplier (~+1x per 0.5 BNB, cap 500x). Split: floor 50% · dividend 35% · community 5% · burn 9% · fission 1%. Verified, low risk.",
    factory: "0xdA3798027cddB2c2aB7d7f5b6947488d630a694D",
    tokenCA: "0xc2c80d9560c5daf91b5a200091fe0d1889e57777",
    tokenLabel: "$CA",
    tokenName: "一个世界",
    tokenSymbol: "一个世界",
    image: "https://flap.mypinata.cloud/ipfs/bafkreich7fgrdn2repnir5nfhxrdgwsexp76v27cxsirnjlkfa3ve6ts3q",
    vaultImage: "/images/floor-protocol-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xc2c80d9560c5daf91b5a200091fe0d1889e57777",
    tags: ["已验证", "低风险", "托底50%", "500x", "质押分红"],
    deployNote:
      "要填：1 项\n\n① 社区钱包\n填你自己的钱包地址（收 5% 税）。\n不要填空地址。",
    deployNoteEn: "Fill: 1 field\n\n① Community wallet\nYour wallet for the 5% tax.\nDo not use an empty address.",
  },
  {
    id: "niu-floor",
    category: "floor",
    name: "十倍托底金库",
    nameEn: "10x Floor Vault",
    summary:
      "链上动态托底 · 池深驱动倍率 · 税浪共振 · 封顶 10 倍。税路：托底 60% · 分红 30% · 社区 3% · 回购 6% · 销毁 1%；分红约每 6 小时释 5%。",
    summaryEn: "On-chain dynamic floor · depth-driven multiplier · tax resonance · 10x cap. Split: floor 60% · dividend 30% · community 3% · buyback 6% · burn 1%; dividend releases ~5% every 6h.",
    factory: "0x603B326c6584eE04a3c3f419e36577590cb5f230",
    tokenCA: "0xf565c31240042a67c88c6d571f70d1b0340b7777",
    tokenLabel: "$CA",
    tokenName: "最牛逼的10倍托底模型+回购+裂变+质押",
    tokenSymbol: "牛",
    image: "https://flap.mypinata.cloud/ipfs/bafybeiemowv2vr3yvq6tp4a6aibwkdc4ysjfjip7ogb777w6abhp5dzbiy",
    vaultImage: "/images/niu-floor-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xf565c31240042a67c88c6d571f70d1b0340b7777",
    tags: ["托底 60%", "10倍封顶", "分红", "回购", "低风险"],
    deployNote:
      "要填：3 项（按顺序）\n\n① 社区钱包\n填你的钱包地址（收 3% 税）。\n\n② 回购间隔\n单位是「分钟」。例如填 10 = 每 10 分钟回购一次。\n\n③ 每次回购比例\n填 1000 = 每次花池子的 10%。\n（10000 = 100%）\n\n税怎么分不用你改，系统已固定。",
    deployNoteEn: "Fill: 3 fields (in order)\n\n① Community wallet (3% tax)\n② Buyback interval in minutes (e.g. 10)\n③ Buyback share: 1000 = 10% of the pool (10000 = 100%)\n\nTax split is fixed on-chain.",
  },
  {
    id: "gold-burn",
    category: "burn",
    name: "金本位燃烧",
    nameEn: "Gold-Standard Burn",
    summary:
      "【蝴蝶守护】烧 Burn大泵 记 BNB 权重 · 分税奖励池 · 领取清零。权重按内外盘 BNB 价值计算；直推 5%、间推 3%；按权重分税 BNB，领取后权重清零。",
    summaryEn: "Butterfly Guard: burn Burn大泵 for BNB weight · share tax rewards · claim resets weight. Weight from bonding/DEX BNB value; direct 5% / indirect 3% invite; claim tax BNB by weight then reset.",
    factory: "0xb100bc44f7f9Ab2a227B74AaFc6FF29C0a51Ae21",
    tokenCA: "0x24625b2d66f2d293ed60d77492527b5e20317777",
    tokenLabel: "$CA",
    tokenName: "BCloud",
    tokenSymbol: "BCloud",
    image: "https://flap.mypinata.cloud/ipfs/bafkreie2c3kunn2qwjob5qqn453ygjkyxk56lannj7t575dspboghngkvm",
    vaultImage: "/images/gold-burn-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x24625b2d66f2d293ed60d77492527b5e20317777",
    tags: ["金本位", "燃烧", "低风险", "蝴蝶守护"],
    startupTax: true,
    deployNote:
      "要填：0 项\n\n粘贴工厂地址后，直接点确认即可。\n发射后约 1 分钟，税会先走开发者地址（正常现象）。",
    deployNoteEn: "Fill: 0 fields\n\nPaste the factory and confirm.\nFor ~1 minute after launch, tax may route to the developer address (expected).",
  },
  {
    id: "dual-buyback",
    category: "buyback",
    name: "双发回购",
    nameEn: "Dual Buyback",
    summary:
      "30 秒双发回购：79% 买混沌销毁 · 20% 赋能鸿蒙销毁 · 1% 裂变。只支持蝴蝶/Flap 发射的代币，无法销毁其他平台代币。",
    summaryEn: "30s dual buyback: 79% buy Chaos to burn · 20% empower Harmony burn · 1% fission. Flap/Butterfly-launched tokens only — cannot burn other-platform tokens.",
    factory: "0xeB05208ccbe3583a402fd3BF43f162b9b65F1D08",
    tokenCA: "0xe8df0cf00d170f8d566b428f7759002894cd7777",
    tokenLabel: "$CA",
    tokenName: "币安时代",
    tokenSymbol: "币安时代",
    image: "https://flap.mypinata.cloud/ipfs/bafkreifhz53x27fcm5gspfuog2t4m6qhxdnjltxravhk54yc4vgz75hqoe",
    vaultImage: "/images/dual-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xe8df0cf00d170f8d566b428f7759002894cd7777",
    tags: ["双发回购", "低风险", "仅蝴蝶代币", "混沌"],
    deployNote:
      "要填：3 项（按顺序，别填反）\n\n① 多久回购一次\n单位是「秒」。例如 30 = 每 30 秒。\n\n② 每次花多少 BNB\n推荐填 0.01。\n\n③ 外币地址\n必须填已经在 Flap/蝴蝶发射过的币。\n发射后改不了。",
    deployNoteEn: "Fill: 3 fields (do not swap)\n\n① Buyback interval in seconds (e.g. 30)\n② BNB per run (recommend 0.01)\n③ External token CA — must already be launched on Flap/Butterfly. Immutable after launch.",
  },
  {
    id: "dual-buyback-tax-adjustable",
    category: "buyback",
    isNew: true,
    name: "双发回购 · 可调税",
    nameEn: "Dual Buyback · Adjustable Tax",
    summary:
      "双发回购税点可调：默认约 79% 主币回购销毁 · 20% 外币赋能销毁 · 1% 裂变（bps 可改）。只支持蝴蝶/Flap 发射的外币，无法销毁其他平台代币。参考 CA：战备公主。",
    summaryEn: "Dual buyback with adjustable tax: default ~79% main-token buyback burn · 20% external empower burn · 1% fission (bps editable). External token must be Flap/Butterfly-launched. Ref CA: 战备公主.",
    factory: "0x17d261AE5D0af06851Cd58FF96706916273Db33f",
    tokenCA: "0x9b5e25921043c350539bf00c55e8a3b537807777",
    tokenLabel: "$CA",
    tokenName: "首创30秒自动拉盘双币销毁 分红比特币",
    tokenSymbol: "比特羊",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreihn2d6uixs6yscu6wfwqxemtuzfij26ypcogjef3u7i5xq6thzgtu",
    vaultImage: "/images/dual-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x9b5e25921043c350539bf00c55e8a3b537807777",
    tags: ["税点可调", "双发回购", "仅蝴蝶代币", "上新"],
    deployNote:
      "要填：一般 6 项（以 Flap 页面为准）\n\n① 多久回购一次（秒）\n② 每次花多少 BNB（推荐 0.01）\n③ 外币地址（必须是 Flap 已发射的币）\n④ 主币占比：不懂就填 0（默认约 79%）\n⑤ 外币占比：不懂就填 0（默认约 20%）\n⑥ 裂变占比：不懂就填 0（默认约 1%）\n\n④⑤⑥ 都填 0 = 用默认。\n若自己改，三数相加要等于 10000。",
    deployNoteEn: "Fill: usually 6 fields (follow Flap UI)\n\n① Interval (seconds)\n② BNB per run (recommend 0.01)\n③ External token CA (Flap-launched)\n④⑤⑥ Shares: leave 0 for defaults (~79% / 20% / 1%). If custom, three numbers must sum to 10000.",
  },
  {
    id: "minute-buyback",
    category: "buyback",
    name: "秒级通缩回购",
    nameEn: "Instant Deflation Buyback",
    summary:
      "秒回购引擎：税路自动回购 · 秒级病毒式裂变。税路固定 99% 回购销毁 / 1% 裂变；创建后约 10 分钟沉淀再开始销毁。已验证，低风险。",
    summaryEn: "Instant buyback engine: auto tax buyback · viral fission. Fixed split 99% buyback burn / 1% fission; ~10 min settle after graduation before burns start. Verified, low risk.",
    factory: "0x4CBb7e6433641826a64670675cCcCe0cBB313C44",
    tokenCA: "0xb75b67cabd07f307ebf4cc8ef271ce4cca457777",
    tokenLabel: "$CA",
    tokenName: "人生太难了qq:1104889362",
    tokenSymbol: "人生太难了",
    image: "https://flap.mypinata.cloud/ipfs/bafkreic2kwxhevql2llginto5o7bbdt2dquqejahtwaekcezsavr2g3u5i",
    vaultImage: "/images/minute-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xb75b67cabd07f307ebf4cc8ef271ce4cca457777",
    tags: ["已验证", "低风险", "秒回购", "99%回购", "1%裂变"],
    deployNote:
      "要填：2 项（顺序千万别反）\n\n① 多久回购一次\n单位是「秒」。例如 60。\n\n② 每次花多少 BNB\n推荐填 0.01。\n\n第一格填秒数，第二格填金额，别对调。",
    deployNoteEn: "Fill: 2 fields (order matters)\n\n① Interval in seconds (e.g. 60)\n② BNB per run (recommend 0.01)\n\nFirst = seconds, second = amount.",
  },
  {
    id: "percent-buyback",
    category: "buyback",
    isNew: true,
    buybackDial: true,
    name: "百分比回购 · 3D",
    nameEn: "Percent Buyback · 3D",
    summary:
      "Percent Buyback pbb-v1：税路固定 99% 回购销毁 / 1% 裂变；创建后约 10 分钟沉淀再开始。每次 Trigger 按 spendBps 消耗回购池百分比（可调），自带 3D 金库 UI。仅支持原生 BNB 发射。",
    summaryEn: "Percent Buyback pbb-v1: fixed 99% buyback burn / 1% fission; ~10 min settle after graduation. Each Trigger spends spendBps % of the buyback pool (adjustable), with 3D vault UI. Native BNB launch only.",
    factory: "0xfd2437DFFB8EBe9F96125b30c85Be22f99Fdddf3",
    tokenCA: "0xf609e7c374ee82001c3c9834c63d8c8cc6ed7777",
    tokenLabel: "$CA",
    tokenName: "妖蝶",
    tokenSymbol: "妖蝶",
    image: "https://flap.mypinata.cloud/ipfs/bafkreief4d5cfjopgtk57hporw7kouiqvmqb6fjhsraoc4g3kdkkn7ntne",
    vaultImage: "/images/percent-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xf609e7c374ee82001c3c9834c63d8c8cc6ed7777",
    tags: ["回购%可调", "3D UI", "99%回购", "pbb-v1", "低风险"],
    deployNote:
      "要填：2 项（顺序别反）\n\n① 多久回购一次\n单位是「秒」。默认可填 600。\n\n② 每次花池子多少\n填 1000 = 每次花 10%。\n填 2000 = 每次花 20%。\n\n只用 BNB 底池发射。",
    deployNoteEn: "Fill: 2 fields (order matters)\n\n① Interval in seconds (default 600)\n② Pool spend: 1000 = 10%, 2000 = 20%\n\nNative BNB quote only.",
  },
  {
    id: "viral-reserve",
    category: "build",
    name: "病毒储备金库",
    nameEn: "Viral Reserve Vault",
    summary:
      "病毒皇冠专用：质押占份、每 6 小时释放 3%、裂变回购、燃烧销毁。已审计，带金库 UI。",
    summaryEn: "Viral Crown: stake for share, release 3% every 6h, fission buyback, burn. Audited, with vault UI.",
    factory: "0x249Ba6875B211df6Fb26565a4fb8bD7c48880965",
    tokenCA: "0x6feb424969261a6bb86364a7c23445d150637777",
    tokenLabel: "$CA",
    tokenName: "裂变+拉盘+分红+销毁+挖矿",
    tokenSymbol: "病毒皇冠",
    image: "https://flap.mypinata.cloud/ipfs/bafybeibhv5znfybbv4jioszmccdntvvuzsyj6de7yrxha2igxcnfj7hloq",
    vaultImage: "/images/viral-reserve-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x6feb424969261a6bb86364a7c23445d150637777",
    tags: ["已审计", "有 UI", "6h释放3%", "裂变回购", "病毒皇冠"],
    deployNote:
      "要填：1 项\n\n① 社区钱包\n填你自己的钱包地址（收税用）。\n不要填空地址。",
    deployNoteEn: "Fill: 1 field\n\n① Community wallet for tax.\nDo not use an empty address.",
  },
  {
    id: "nifeng-fanpan",
    category: "build",
    name: "逆风翻盘 · 两池建设",
    nameEn: "Comeback · Dual-Pool Build",
    summary:
      "生态赋能：质押分红 · 邀请拿奖励 · 两池自动释放。税分成：1% 裂变、9% 销毁、10% 基金会、80% 进两池（邀请池 30% + 质押池 70%）；每 30 分钟各释 0.6%。",
    summaryEn: "Eco boost: stake dividends · invite rewards · dual-pool auto release. Split: 1% fission, 9% burn, 10% foundation, 80% to pools (invite 30% + stake 70%); each pool releases 0.6% every 30 min.",
    factory: "0x9b58f7fAc768F426C6c292074Cb0c459Da494804",
    tokenCA: "0x0651b8d5622178c6887194a6a3aaf3e8e1117777",
    tokenLabel: "$CA",
    tokenName: "逆转奇迹",
    tokenSymbol: "逆转奇迹",
    image: "https://flap.mypinata.cloud/ipfs/bafybeiexcgqq5fix7py4wnu7c4ys6k643gqgkouh3r3nwwuffj26iykxsi",
    vaultImage: "/images/nifeng-fanpan-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x0651b8d5622178c6887194a6a3aaf3e8e1117777",
    tags: ["低风险", "已上市", "两池释放", "质押分红", "邀请奖励"],
    startupTax: true,
    deployNote:
      "按 Flap 页面提示填基金会等地址即可。\n不懂的字段按页面默认/提示来。\n发射后约 1 分钟税会先走开发者地址（正常）。",
    deployNoteEn: "Follow Flap prompts for foundation wallets.\nUnknown fields: keep defaults.\n~1 minute post-launch tax via developer address is expected.",
  },
  {
    id: "build-vault-aster",
    category: "build",
    name: "ASTER 永动建设",
    nameEn: "ASTER Perpetual Build",
    summary:
      "9INF-V5 链上全自动释放：正常质押 · 传播排行榜 · 两池分红。税路：1% 裂变回购 · 9% 销毁回购（约每10分钟，单次最多0.01 BNB）· 10% 基金会 · 80% 两池（邀请30% + 质押70%，每6小时各释3%）。",
    summaryEn: "9INF-V5 fully automatic release: stake · invite leaderboard · dual-pool dividends. Split: 1% fission buyback · 9% burn buyback (~every 10 min, ≤0.01 BNB) · 10% foundation · 80% dual pools (invite 30% + stake 70%, 3% each / 6h).",
    factory: "0xEd8c7eF6e73F9F1B9fF1a590e503a5EEA4e5B663",
    tokenCA: "0x1b2fd52ba25f9b39ca0f0d78fe238cd80a817777",
    tokenLabel: "$CA",
    tokenName: "质押+裂变+分红+销毁+自拉",
    tokenSymbol: "万象金库",
    image: "https://flap.mypinata.cloud/ipfs/bafybeidw24azzxckcgipp6msvqudfk4jn2lz267a2wywfgt7ovzxyj6vjy",
    vaultImage: "/images/build-vault-aster.webp",
    flapUrl: "https://flap.sh/bnb/0x1b2fd52ba25f9b39ca0f0d78fe238cd80a817777",
    tags: ["低风险", "内盘", "6h释放3%", "两池分红", "ASTER"],
    deployNote:
      "按 Flap 页面提示填基金会等地址即可。\n不懂就跟页面提示填，不要留空。",
    deployNoteEn: "Follow Flap prompts for foundation wallets.\nDo not leave required fields empty.",
  },
  {
    id: "hold-dividend-buyback",
    category: "buyback",
    isNew: true,
    name: "持币分红回购",
    nameEn: "Hold Dividend Buyback",
    summary:
      "税路三拆：1% 即时裂变 · 29% 进回购池（约 10 分钟沉淀后按额度销毁，单次 0.01 BNB）· 70% 持币达标可领分红。默认持币门槛 1 万起步。已验证，低风险。",
    summaryEn: "Three-way tax: 1% instant fission · 29% buyback pool (~10 min settle then burn by size, 0.01 BNB each) · 70% hold-to-claim dividend. Default hold threshold 10k. Verified, low risk.",
    factory: "0x55CeB6C7Db75bd0d1f04bF8025E976AafB3f5132",
    tokenCA: "0xdfca7c49faaf02fb18cf067556f24a330c177777",
    tokenLabel: "$CA",
    tokenName: "分红+双重销毁+裂变+自拉",
    tokenSymbol: "四象玲珑",
    image: "https://flap.mypinata.cloud/ipfs/bafybeichxdbq24ke7krmgu72lgysdnwvvqngssuy2666or4ngyxtznv3ry",
    vaultImage: "/images/hold-dividend-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xdfca7c49faaf02fb18cf067556f24a330c177777",
    tags: ["低风险", "1%/29%/70%", "持币分红", "回购销毁", "裂变"],
    riskTip:
      "【风险提示】分红代币若链上流动性不足可能会导致分红失败，非金库机制安全问题，请自行研究 DYOR。持币分红模板要求：分红 TOKEN 的 Pancake V2 BNB 单边流动性建议 ≥ 3 BNB；若所选分红币无流动性导致损失，非金库问题。",
    riskTipEn:
      "Risk: thin on-chain liquidity for the dividend token may cause dividend failure — this is not a vault-mechanism safety issue; DYOR. Hold-dividend templates recommend ≥ 3 BNB one-sided Pancake V2 BNB liquidity. Losses from an illiquid dividend TOKEN are not a vault issue.",
    deployNote:
      "要填：2 项\n\n① 分红币地址\n填用来发分红的币（例如 XAUt）。须有 Pancake V2 BNB 交易对；建议池内 BNB ≥ 3，站内部署会校验单边须 > 2 BNB。\n\n② 持币门槛（税币数量）\n默认 1 万起步；填多少写多少，下方「持币分红条件」与 Portal 最低持仓同步。\n其他税点已固定，不用你改。\n\n【风险】分红币流动性不足可能导致分红失败，非金库机制问题，DYOR。",
    deployNoteEn:
      "Fill: 2 fields\n\n① Dividend token CA (e.g. XAUt). Needs Pancake V2 BNB pair; recommend ≥ 3 BNB in pool; on-site deploy requires > 2 BNB one-side.\n② Hold threshold (tax-token amount; default 10k)\nOther tax points are fixed.\n\nRisk: thin dividend-token liquidity may fail payouts — not a vault bug; DYOR.",
  },
  {
    id: "hold-dividend-tax-adjustable",
    category: "buyback",
    isNew: true,
    name: "持币分红 · 可调税",
    nameEn: "Hold Dividend · Adjustable Tax",
    summary:
      "持币达标领外币分红 · 回购销毁 · 裂变；税点可调。默认 1% 裂变 / 29% 销毁 / 70% 分红（⑤⑥⑦ 全填 0 即用默认）。买分红固定每次 0.05 BNB。顶层「分红」税必须设 0%（金库外部分红）。未验证模板，风险自负。",
    summaryEn: "Hold threshold for external dividend · buyback burn · fission; tax adjustable. Default 1% fission / 29% burn / 70% dividend (set ⑤⑥⑦ to 0 for defaults). Buy dividend fixed 0.05 BNB each. Top-level Dividend tax must be 0% (vault-managed). Unverified template — use at your own risk.",
    factory: "0x6e701AF815546F55920690BD2FCbc1eC308cE041",
    tokenCA: "0xf84048b1a6f04b0ff71e122443c7fa4418777777",
    tokenLabel: "$CA",
    tokenName: "852255709",
    tokenSymbol: "黄金狗",
    image: "https://flap.mypinata.cloud/ipfs/bafybeif2axxw5a64ijg7r2e63fuh7bh6ihlvcynqcbb74nn7aa3lflix7a",
    vaultImage: "/images/hold-dividend-tax-adjustable-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xf84048b1a6f04b0ff71e122443c7fa4418777777",
    tags: ["税点可调", "持币分红", "回购销毁", "裂变", "未验证"],
    riskTip:
      "【风险提示】分红代币若链上流动性不足可能会导致分红失败，非金库机制安全问题，请自行研究 DYOR。持币分红模板要求：分红 TOKEN 的 Pancake V2 BNB 单边流动性建议 ≥ 3 BNB；若所选分红币无流动性导致损失，非金库问题。",
    riskTipEn:
      "Risk: thin on-chain liquidity for the dividend token may cause dividend failure — this is not a vault-mechanism safety issue; DYOR. Hold-dividend templates recommend ≥ 3 BNB one-sided Pancake V2 BNB liquidity. Losses from an illiquid dividend TOKEN are not a vault issue.",
    deployNote:
      "要填：7 项（按页面顺序）\n\n① 分红币地址（须 V2 BNB 对；建议 ≥ 3 BNB，站内校验 > 2 BNB）\n② 持币门槛（税币数量）：默认 1 万起步；填多少写多少，下方条件预览与 Portal「最低持仓」同步\n③ 间隔秒数（多久跑一次）\n④ 每次销毁花多少 BNB（推荐 0.01）\n⑤⑥⑦ 三个占比：不懂全填 0（默认约 1% / 29% / 70%）\n\n注意：发射页顶层「分红」必须填 0%。\n税只给这个工厂分。\n\n【风险】分红币流动性不足可能导致分红失败，非金库机制问题，DYOR。",
    deployNoteEn:
      "Fill: 7 fields (Flap order)\n\n① Dividend token (V2 BNB pair; recommend ≥ 3 BNB; on-site requires > 2 BNB)\n② Hold threshold (default 10k)\n③ Interval seconds\n④ Burn BNB per run (recommend 0.01)\n⑤⑥⑦ Shares: all 0 = defaults (~1% / 29% / 70%)\n\nTop-level Dividend tax on the launch page must be 0%.\n\nRisk: thin dividend-token liquidity may fail payouts — not a vault bug; DYOR.",
    deployShots: [
      {
        src: "/images/hold-dividend-tax-adjustable-params.webp",
        alt: "未上架税收模板 · 7 项参数",
      },
      {
        src: "/images/hold-dividend-tax-adjustable-tax.webp",
        alt: "发射页税分配 · 顶层分红须为 0%",
      },
    ],
  },
  {
    id: "stake-realtime-dividend",
    category: "build",
    isNew: true,
    name: "质押实时分红",
    nameEn: "Realtime Stake Dividend",
    summary:
      "首创升级版双池质押分红：买币即计分红 · 无锁仓自由解除（进出约 0.1% 手续费）。税路：1% 裂变 · 9% 销毁回购（BNB 底池）· 10% 基金会 · 80% 两池（邀请 30% + 质押 70%）。分红代币可选。",
    summaryEn: "Dual-pool stake dividend: buy counts toward dividends · unlock anytime (~0.1% in/out fee). Split: 1% fission · 9% burn buyback (BNB quote) · 10% foundation · 80% pools (invite 30% + stake 70%). Dividend token optional.",
    factory: "0x009e4998c136EeDA7C6b23CB64f56fd0D96122F8",
    tokenCA: "0x751868b29bdb5ae722c4f2f0c36d2d33360d7777",
    tokenLabel: "$CA",
    tokenName: "首创双池质押分红平台币共识群1102830256",
    tokenSymbol: "宝贝雪球",
    image: "https://flap.mypinata.cloud/ipfs/bafkreih6hn3sqptn4joz37zlqkumixajmiqihgfazyrmifcfnzilj22uuy",
    vaultImage: "/images/stake-realtime-dividend-vault.png",
    flapUrl: "https://flap.sh/bnb/0x751868b29bdb5ae722c4f2f0c36d2d33360d7777",
    tags: ["低风险", "双池分红", "实时分红", "BNB底池", "无锁仓"],
    startupTax: true,
    deployNote:
      "按 Flap 页面提示填即可。\n\n分红币地址：可以不填。\n基金会等地址：按页面提示填你的钱包。\n发射后约 1 分钟税会先走开发者地址（正常）。",
    deployNoteEn: "Follow Flap prompts.\n\nDividend token: optional.\nFoundation wallets: your addresses.\n~1 minute post-launch developer tax routing is expected.",
    deployShots: [
      {
        src: "/images/stake-realtime-dividend-vault.png",
        alt: "MarsCoin 质押即领 · 邀请池/质押池",
      },
      {
        src: "/images/stake-realtime-dividend-board.png",
        alt: "邀请/质押排行榜与税点分配",
      },
    ],
  },
  {
    id: "pinksale-dividend",
    category: "build",
    isNew: true,
    name: "粉红溢价 · 365天锁",
    nameEn: "Pink Premium · 365d Lock",
    summary:
      "pink-v1.4：税币经金库锁进 PinkSale 官方粉红锁（固定 365 天 cliff，不可改）。税路：0.1% 裂变 · 30% 粉红溢价池（市价 110% 收币即烧，单笔≤池 20%）· 69.9% 按权重分 BNB 给锁仓人。已验证，低风险；部署无需填参。",
    summaryEn: "pink-v1.4: tax tokens lock into PinkSale official pink lock (fixed 365d cliff). Split: 0.1% fission · 30% pink premium pool (buy at 110% market then burn, ≤20% pool per tx) · 69.9% BNB to lockers by weight. Verified, low risk; no deploy params.",
    factory: "0x652159Ded01D33EeE8b603C9D51F3cd110bAcF75",
    tokenCA: "0x80be478995f5df93a121214b8e96a66e25c87777",
    tokenLabel: "$CA",
    tokenName: "FLAPBURN",
    tokenSymbol: "FLAPBURN",
    image: "https://flap.mypinata.cloud/ipfs/bafybeib23fob5fm6z3g742lzyaqiu75bjfusu4rvxdodltumyclcyveel4",
    vaultImage: "/images/pinksale-dividend-vault.png",
    flapUrl: "https://flap.sh/bnb/0x80be478995f5df93a121214b8e96a66e25c87777",
    tags: ["已验证", "低风险", "PinkSale", "固定365天", "溢价池"],
    startupTax: true,
    deployNote:
      "要填：0 项\n\n粘贴工厂 → 直接确认。\n锁仓固定 365 天，不用你填。\n想自己选天数，请用「锁仓时间可调」版。",
    deployNoteEn: "Fill: 0 fields\n\nPaste factory → confirm.\nLock is fixed at 365 days.\nFor adjustable days, use the lock-days edition.",
    deployShots: [
      {
        src: "/images/pinksale-dividend-deploy.png",
        alt: "Flap 启用 Vault · 已验证模板无需配置",
      },
      {
        src: "/images/pinksale-dividend-board.png",
        alt: "粉红权重榜与税点分配",
      },
    ],
  },
  {
    id: "pinksale-dividend-lock-days",
    category: "build",
    isNew: true,
    name: "粉红溢价 · 可调锁仓",
    nameEn: "Pink Premium · Adjustable Lock",
    summary:
      "pink-v1.5：与固定版同税路，锁仓天数可调。vaultData = abi.encode(uint256 lockDays)，夹紧 7～1095 天（空/非法默认 365），发射后不可改。0.1% 裂变 · 30% 溢价池（市价 110% 收币即烧）· 69.9% 锁仓人分 BNB。",
    summaryEn: "pink-v1.5: same tax as fixed edition; lock days adjustable. vaultData = abi.encode(uint256 lockDays), clamped 7–1095 (empty/invalid → 365), immutable after launch. 0.1% fission · 30% premium pool (110% buy-burn) · 69.9% BNB to lockers.",
    factory: "0x92C5334a440485986F733490c0B5CF0ec19fD833",
    tokenCA: "0x914616d1a69632ee41a1d7d71b754f2d586b7777",
    tokenLabel: "$CA",
    tokenName: "羊羊得亿",
    tokenSymbol: "羊羊得亿",
    image: "https://flap.mypinata.cloud/ipfs/bafybeidhyvkzwgvcrzd6q2hnsqybwjriebonfgw223xnfe2a2gwvnhh7ry",
    vaultImage: "/images/pinksale-lock-days-board.png",
    flapUrl: "https://flap.sh/bnb/0x914616d1a69632ee41a1d7d71b754f2d586b7777",
    tags: ["锁仓可调", "PinkSale", "7～1095天", "溢价池", "pink-v1.5"],
    startupTax: true,
    deployNote:
      "要填：1 项\n\n① 锁仓天数\n单位是「天」。可填 7～1095。\n不填默认 365。\n发射后改不了。",
    deployNoteEn: "Fill: 1 field\n\n① Lock days (7–1095). Default 365 if empty.\nImmutable after launch.",
    deployShots: [
      {
        src: "/images/pinksale-lock-days-board.png",
        alt: "PinkSale 分红金库 · 锁仓与领取 BNB",
      },
      {
        src: "/images/pinksale-lock-days-premium.png",
        alt: "粉红溢价池 · 多拿 10% 收币即烧",
      },
    ],
  },
  {
    id: "stock-stake-dividend",
    category: "stock",
    isNew: true,
    name: "质押分红 · 股票底",
    nameEn: "Stake Dividend · Stock Quote",
    summary:
      "股票底池首发 · Stock Stake Dividend ssd-v1：发射底必须是股票 ERC20（不可用原生 BNB）。质押税币拿股票分红；可选最低质押门槛 minStake（0=不设）。",
    summaryEn: "Stock-quote first launch · Stock Stake Dividend ssd-v1: quote must be stock ERC20 (no native BNB). Stake tax token for stock dividends; optional minStake (0 = none).",
    factory: "0xc01c6491d3497bF2A55F3bfd93B0AdFAe5a23548",
    tokenCA: "0x05e14a1e71a3e177b081192d0525f03eb9f07777",
    tokenLabel: "$CA",
    tokenName: "全网最新首创机制双质押分红",
    tokenSymbol: "赵财猫",
    image: "https://flap.mypinata.cloud/ipfs/bafybeibdnyhq6dcpuovvxrak2vq2az45o3p263tggbhdqmvof5gqkjpvea",
    vaultImage: "/images/stock-stake-dividend-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x05e14a1e71a3e177b081192d0525f03eb9f07777",
    tags: ["股票底池", "ssd-v1", "质押分红", "本币→股票", "首发"],
    deployNote:
      "要填：1 项\n\n① 最低质押量\n填 0 = 不设门槛。\n\n重要：发射时底池必须选「股票币」，不能选 BNB。",
    deployNoteEn: "Fill: 1 field\n\n① Minimum stake (0 = none)\n\nImportant: quote must be a stock token, not BNB.",
  },
  {
    id: "stock-percent-buyback",
    category: "stock",
    isNew: true,
    buybackDial: true,
    name: "股票底 · 百分比回购",
    nameEn: "Stock Quote · Percent Buyback",
    summary:
      "股票底百分比回购 spbb-v1：税路 99% 回购销毁 / 1% 裂变；FlapTrigger 公有托底 + 手动「立即回购」。每次按 spendBps 消耗回购池百分比，冷却可调。支持全部股票底池（SPCXB / XAUt / 海力士等），不可用原生 BNB。",
    summaryEn: "Stock percent buyback spbb-v1: 99% buyback burn / 1% fission; FlapTrigger public floor + manual Instant Buyback. Each run spends spendBps % of pool; cooldown adjustable. All stock quotes (SPCXB / XAUt / Hynix, etc.); no native BNB.",
    factory: "0x62bD1e39Cf54E8280d7cEC93382D17569bFdeE28",
    tokenCA: "0xcb2bb4d0f2ceb709e8d66f5db82370b19bfb7777",
    tokenLabel: "$CA",
    tokenName: "上演速度与激情",
    tokenSymbol: "速度与激情",
    image: "https://flap.mypinata.cloud/ipfs/bafkreidsnb6f2lct7crk5cvpkmc4tzdki2ldiedgf4x2uvtzcib3rmyepa",
    vaultImage: "/images/stock-percent-buyback-vault.png",
    flapUrl: "https://flap.sh/bnb/0xcb2bb4d0f2ceb709e8d66f5db82370b19bfb7777",
    tags: ["股票底池", "百分比回购", "自动裂变", "99%回购", "全股票底"],
    startupTax: true,
    deployNote:
      "要填：2 项（顺序别反）\n\n① 多久回购一次\n单位是「秒」。例如 10 = 每 10 秒。\n\n② 每次花池子多少\n填 1000 = 每次花 10%。\n填 2000 = 每次花 20%。\n\n重要：发射时底池必须选「股票币」（任意股票底均可），不能选 BNB。",
    deployNoteEn: "Fill: 2 fields (order matters)\n\n① Interval seconds (e.g. 10)\n② Pool spend: 1000 = 10%, 2000 = 20%\n\nImportant: quote must be a stock token, not BNB.",
  },
  {
    id: "battle-royale-3d",
    category: "stock",
    isNew: true,
    name: "股票大逃杀 · 3D",
    nameEn: "Stock Battle Royale · 3D",
    summary:
      "大逃杀 Resbr-v1 · 3D 金库 UI：幸存者博弈类税路金库。发射底必须是股票 ERC20（不可用原生 BNB），支持 SPCXB / SPYB / XAUt 等股票底。",
    summaryEn: "Battle Royale Resbr-v1 · 3D vault UI: survivor-game tax vault. Quote must be stock ERC20 (no native BNB); supports SPCXB / SPYB / XAUt, etc.",
    factory: "0x8B43a3F5ca2df250269d69C2f20707372550955B",
    tokenCA: "0xbd41b8b248e52df254fbb6229ca2c3ce30607777",
    tokenLabel: "$CA",
    tokenName: "StonksFomo 3D",
    tokenSymbol: "StonksFomo",
    image: "https://flap.mypinata.cloud/ipfs/bafybeied7i2sx5zlclohx4sax7o4zsc4s6qfxrs3naos4ye6f46t4s7cwi",
    vaultImage: "/images/battle-royale-3d-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xbd41b8b248e52df254fbb6229ca2c3ce30607777",
    tags: ["大逃杀", "3D UI", "Resbr-v1", "股票底池", "新"],
    deployNote:
      "要填：2 项\n\n① 奖池划出（bps）\n默认 500 = 每局 5%。\n\n② 开奖延迟（秒）\n默认 180；上限 600。\n\n重要：发射时底池必须选「股票币」，不能选 BNB。",
    deployNoteEn: "Fill: 2 fields\n\n① Prize cut bps (default 500 = 5%)\n② Draw delay seconds (default 180; max 600)\n\nImportant: quote must be a stock token, not BNB.",
  },
  {
    id: "stock-hold-dual-dividend",
    category: "stock",
    isNew: true,
    name: "持币双分红 · 股票底",
    nameEn: "Hold Dual Dividend · Stock Quote",
    summary:
      "持币双分红 · 任意股票底池：发射底必须是股票 ERC20（SPCXB / XAUt / 海力士等均可，不可用原生 BNB）。持仓领双分红；变异/分红币须已有 BNB 交易对（金库用 BNB 买入分红）。",
    summaryEn: "Hold dual dividend · any stock quote: quote must be stock ERC20 (SPCXB / XAUt / Hynix, etc.; no native BNB). Hold for dual dividends; dividend assets need a BNB pair (vault buys dividends with BNB).",
    factory: "0x15050930792A018bc3ac53cBbF0CC1C9C5723EF8",
    tokenCA: "0xa744c37bfb34fa88cb9ee2409b1c1473d4577777",
    tokenLabel: "$CA",
    tokenName: "全网首创股票底池双币分红",
    tokenSymbol: "齐天小圣",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeibqdtiouncz3fhakjhhdfib5hnx7k2uqy4bsggmgj46yb5xex7wji",
    vaultImage:
      "https://flap.mypinata.cloud/ipfs/bafkreidrwyibkkhqm3qupwbb22dtu6ahm5i3hpzq56btmldttv4rl6n7ry",
    flapUrl: "https://flap.sh/bnb/0xa744c37bfb34fa88cb9ee2409b1c1473d4577777",
    tags: ["持币双分红", "任意股票底", "上新", "BNB交易对"],
    riskTip:
      "【风险提示】分红代币若链上流动性不足可能会导致分红失败，非金库机制安全问题，请自行研究 DYOR。持币分红模板要求：分红 TOKEN 的 Pancake V2 BNB 单边流动性建议 ≥ 3 BNB；若所选分红币无流动性导致损失，非金库问题。",
    riskTipEn:
      "Risk: thin on-chain liquidity for the dividend token may cause dividend failure — this is not a vault-mechanism safety issue; DYOR. Hold-dividend templates recommend ≥ 3 BNB one-sided Pancake V2 BNB liquidity. Losses from an illiquid dividend TOKEN are not a vault issue.",
    deployNote:
      "要填：2 项\n\n① 分红资产 A（可手填任意有 BNB 对的 ERC20；建议 V2 BNB ≥ 3，站内校验 > 2 BNB）\n② 分红资产 B\n两者不可相同，也不可与发射底池相同。\n\n税收分配：分红追踪器必须为 0%（金库外部管理收益）。\n\n重要：发射时底池必须选「股票币」（任意股票底均可），不能选 BNB。\n\n【风险】分红币流动性不足可能导致分红失败，非金库机制问题，DYOR。",
    deployNoteEn:
      "Fill: 2 fields\n\n① Dividend asset A (ERC20 with BNB pair; recommend ≥ 3 BNB; on-site requires > 2 BNB)\n② Dividend asset B\nMust differ from each other and from the quote.\n\nDividend tracker must be 0%.\nQuote must be a stock token, not BNB.\n\nRisk: thin dividend-token liquidity may fail payouts — not a vault bug; DYOR.",
  },
  {
    id: "coin-stock-nft-bbk-v3",
    category: "stock",
    isNew: true,
    name: "币股 NFT · bbk-v3",
    nameEn: "Coin-Stock NFT · bbk-v3",
    summary:
      "【蝴蝶币股NFT bbk-v3】销毁税币铸造币股 NFT；税收按比例拆持有奖励（最多 10 股均摊 · 每腿约 0.025 BNB · 按 NFT 领取）与地板池（quote 卖回销毁）。图像：空/零地址=默认 FLAPixel；Schema 地址=自订 SVG；URL=外部 JSON。底池必须是股票 ERC20，不可用原生 BNB。",
    summaryEn: "Butterfly coin-stock NFT bbk-v3: burn tax tokens to mint NFTs; tax splits hold rewards (up to 10 stocks averaged · ~0.025 BNB/leg · claim per NFT) and floor pool (quote sell-to-burn). Art: empty/zero = default FLAPixel; Schema = custom SVG; URL = external JSON. Quote must be stock ERC20, not native BNB.",
    factory: "0xe524D478a55F2159bD81145c24BDDC93Dbe89def",
    tokenCA: "0x4f0aa31a98368508675b2cdead0f88836a427777",
    tokenLabel: "$CA",
    tokenName: "BullMars",
    tokenSymbol: "BullMars",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeicwm5x2qqwc5xbsog5tseg5vz7aegag4imqu6fsi4ed3v5kikpnp4",
    vaultImage:
      "https://flap.mypinata.cloud/ipfs/bafkreidrwyibkkhqm3qupwbb22dtu6ahm5i3hpzq56btmldttv4rl6n7ry",
    flapUrl: "https://flap.sh/bnb/0x4f0aa31a98368508675b2cdead0f88836a427777",
    tags: ["币股NFT", "bbk-v3", "燃烧铸造", "持有奖励", "地板池", "股票底池"],
    deployNote:
      "用站内填参页生成 vaultData：打开「填参部署」→ 填 NFT / 比例 / 变异股 → 复制工厂 + vaultData → 去 Flap 自定义 Factory 启用。\n\n也可手填（按 Flap 顺序）：\n① NFT 名称 / 符号\n② 最大供应量 · 初始托底 NFT 数\n③ 每个 NFT 销毁税币数量（按税币精度）\n④ 持有奖励% + 地板池%（两者之和=100）\n⑤ 图像 artSource：空或零地址=默认 FLAPixel\n⑥ 变异股 asset0（必填）…asset9（未用填零地址）\n\n自定义分红资产：须有 Pancake V2 的 BNB 交易对，且池内 BNB ≥ 0.05。\n\n重要：发射时底池必须选「股票币」，不能选 BNB。",
    deployNoteEn: "Use on-site deploy to build vaultData, or fill Flap fields:\n① NFT name/symbol\n② Max supply · initial floor NFT count\n③ Tax tokens burned per NFT\n④ Hold reward % + floor pool % (=100)\n⑤ Art source (empty/zero = FLAPixel)\n⑥ Mutation stocks asset0…asset9\n\nCustom dividend assets need Pancake V2 BNB pair with ≥0.05 BNB.\nQuote must be a stock token, not BNB.",
  },
  {
    id: "stock-lp-reslp",
    category: "stock",
    isNew: true,
    name: "持币分红 LP · 股票底",
    nameEn: "Hold Dividend LP · Stock Quote",
    summary:
      "持币分红 LP · 股票税分账：销毁 · 裂变 · 囤 LP。内盘 49.9% 销毁 / 0.1% 裂变 / 50% LP分红（毕业前 LP 只囤不加池）；外盘 19.9% 销毁 / 0.1% 裂变 / 80% LP分红（毕业后按量子加池并注入 Dividend）。自动回购冷却可配间隔与单次销毁比例；发射后每次加池分红按底池股票代币计。底池须为股票 ERC20，不可用原生 BNB；Portal 分红追踪器须为 0%（MAGIC）。",
    summaryEn: "Hold dividend LP · stock tax split: burn · fission · LP accumulate. Bonding 49.9% burn / 0.1% fission / 50% LP dividend (pre-grad LP only accumulates); DEX 19.9% burn / 0.1% fission / 80% LP dividend (post-grad quantum add + Dividend). Auto buyback cooldown interval + spend % configurable. Quote must be stock ERC20; Portal dividend tracker must be 0% (MAGIC).",
    factory: "0x7ADcDb399D1eC28bA460D537BCE412aa375A9199",
    tokenCA: "0x221f6c14438862f6b0e698a2121b273aa60a7777",
    tokenLabel: "$CA",
    tokenName: "首创股票内盘销毁外盘分红lp机制",
    tokenSymbol: "屎壳郎股票",
    image: "https://flap.mypinata.cloud/ipfs/bafybeiecu2e6zmhhcbdrzptelo7ihbagb7rv4hfydefgbmd6alhzs7h4oy",
    vaultImage: "/images/stock-percent-buyback-vault.png",
    flapUrl: "https://flap.sh/bnb/0x221f6c14438862f6b0e698a2121b273aa60a7777",
    tags: ["持币分红LP", "自动回购", "裂变", "销毁池", "股票底池", "上新"],
    riskTip:
      "【风险提示】分红代币若链上流动性不足可能会导致分红失败，非金库机制安全问题，请自行研究 DYOR。持币分红模板要求：相关 TOKEN 的 Pancake V2 BNB 单边流动性建议 ≥ 3 BNB；若流动性不足导致损失，非金库问题。",
    riskTipEn:
      "Risk: thin on-chain liquidity may cause dividend failure — this is not a vault-mechanism safety issue; DYOR. Hold-dividend templates recommend ≥ 3 BNB one-sided Pancake V2 BNB liquidity. Losses from insufficient liquidity are not a vault issue.",
    deployNote:
      "要填：3 项（对齐金库 UI「回购冷却」）\n\n① 回购间隔（秒）\n默认 60，上限 600。\n\n② 单次销毁比例\n填 1000 = 10%（花销毁池的比例）。\n\n③ 发射后每次加池分红（量子）\n按底池股票代币计，范围 0.01–1；例 0.1 = 底池股票代币 0.1。毕业后按此量子加池并注入 Dividend。\n\n税路（链上固定）：内盘 49.9%/0.1%/50%；外盘 19.9%/0.1%/80%。\n税收分配：分红追踪器必须填 0%（MAGIC）。\n\n重要：发射时底池必须选「股票币」，不能选 BNB。\n\n【风险】流动性不足可能导致分红失败，非金库机制问题，DYOR。",
    deployNoteEn:
      "Fill: 3 fields (UI buyback cooldown)\n\n① Interval seconds (default 60; max 600)\n② Burn share: 1000 = 10% of burn pool\n③ Post-grad add quantum in quote stock tokens (0.01–1)\n\nOn-chain tax fixed. Dividend tracker must be 0% (MAGIC).\nQuote must be a stock token, not BNB.\n\nRisk: thin liquidity may fail payouts — not a vault bug; DYOR.",
  },
  {
    id: "floor-mult-unlimited",
    category: "flex",
    isNew: true,
    name: "托底倍率无上限",
    nameEn: "Uncapped Floor Multiplier",
    summary:
      "托底倍率无上限：税路 90% 托底 · 9% 回购 · 1% 作者。BNB/ETH 等 CRYPTO 与股票底全底池；约 0.01 BNB 开 1×，每 +0.3 BNB +1×、无封顶；回购约 1 分钟花池 50%。链上无需 vaultData。",
    summaryEn:
      "Uncapped floor multiplier: tax 90% floor · 9% buyback · 1% author. BNB/ETH crypto or stock multi-quote; ~0.01 BNB opens 1×, +1× per +0.3 BNB, no cap; buyback ~50%/min. No vaultData on-chain.",
    factory: "0xcDE4E0a5F29C14A1D361Cf6A9FB4C274fEDddAD2",
    tokenCA: "0x519469f9f51e15c6342f99735b71d8eea6177777",
    tokenLabel: "$CA",
    tokenName: "狗自拉",
    tokenSymbol: "狗自拉",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeicnfxbp45qt3scs4wazxnnrouqsd7vawdoo725s4jw32pzixnvg6m",
    vaultImage: "/images/floor-protocol-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x519469f9f51e15c6342f99735b71d8eea6177777",
    tags: ["全底池", "托底90%", "无上限", "回购9%", "CRYPTO+RWA", "上新"],
    startupTax: true,
    deployNote:
      "要填：0 项\n\n粘贴工厂地址后，直接点确认即可。\n支付底可在 CRYPTO（BNB / ETH / USDT 等）或 RWA（股票底/黄金等）中任选。\n发射后约 1 分钟税会先走开发者地址（正常现象）。",
    deployNoteEn:
      "Fill: 0 fields\n\nPaste factory and confirm.\nQuote may be CRYPTO (BNB / ETH / USDT…) or RWA (stock/gold…).\n~1 minute post-launch developer tax routing is expected.",
  },
  {
    id: "pure-fission",
    category: "flex",
    isNew: true,
    name: "纯粹裂变金库",
    nameEn: "Pure Fission Vault",
    summary:
      "纯粹裂变（病毒裂变 vfis-v1）：固定 1% 来税即裂 + 99% 队列裂变。填 Trigger 间隔（0～60 秒）与队列 spendBps（默认 1000=10%）。支持 BNB / ETH 等 CRYPTO 与股票底等官方 quote（全底池）。",
    summaryEn:
      "Pure fission (Virus Fission vfis-v1): fixed 1% instant + 99% queue. Set Trigger interval (0–60s) and queue spendBps (default 1000=10%). Supports BNB/ETH crypto and official stock quotes (multi-quote).",
    factory: "0xa05A6f2d1e8783320e72F4ab199D1330eA19Bf34",
    tokenCA: "0x9c4c34700ddc35e9f508c01de66975fb2bc27777",
    tokenLabel: "$CA",
    tokenName: "BNCVIRUS",
    tokenSymbol: "BNCVIRUS",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeiaskejsv2jno5ie235ncxosxnzmicnxh6ajwgjlwj73mw3lkd7xpe",
    vaultImage: "/images/minute-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x9c4c34700ddc35e9f508c01de66975fb2bc27777",
    tags: ["全底池", "裂变", "上新", "vfis-v1", "CRYPTO+RWA"],
    startupTax: true,
    deployNote:
      "要填：2 项\n\n① Trigger 间隔（秒）：0～60，默认 60\n② 队列每次裂变占比 spendBps：100～10000（1000=10%），默认 1000\n\n支付底可在 CRYPTO（BNB / ETH / USDT 等）或 RWA（股票底/黄金等）中任选官方已启用底。\n发射后约 1 分钟税会先走开发者地址（正常现象）。",
    deployNoteEn:
      "Fill: 2 fields\n\n① Trigger interval seconds: 0–60 (default 60)\n② Queue spendBps: 100–10000 (1000=10%, default 1000)\n\nQuote may be CRYPTO (BNB / ETH / USDT…) or RWA (stock/gold…) if Portal-enabled.\n~1 minute post-launch developer tax routing is expected.",
  },
  {
    id: "stock-gold-burn-dividend",
    category: "flex",
    isNew: true,
    name: "金本位燃烧分红 · 全底池",
    nameEn: "Gold Burn Dividend · Multi-Quote",
    summary:
      "Gold Burn Dividend gbd-v1：烧税币记权重 · 分税奖励池 · 领取清零。链上无需 vaultData；支持 BNB / ETH 等 CRYPTO 与股票底/黄金等官方 quote（全底池）。",
    summaryEn: "Gold Burn Dividend gbd-v1: burn tax tokens for weight · share tax rewards · claim resets. No vaultData on-chain; supports BNB/ETH crypto and stock/gold official quotes (multi-quote).",
    factory: "0x926fa7791f5EA5E70d8582ED32953e617301e5Eb",
    tokenCA: "0xe012ee9d827343444bed94a1b15d6bd110797777",
    tokenLabel: "$CA",
    tokenName: "BurnXAUT由burn原团队打造",
    tokenSymbol: "BurnXAUT",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeigsat4nm6y4cg4qvqf6dm24mk65tascy4zdkwmbjgd73zuvdemiwa",
    vaultImage: "/images/gold-burn-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xe012ee9d827343444bed94a1b15d6bd110797777",
    tags: ["全底池", "金本位", "燃烧", "分红股票", "gbd-v1", "CRYPTO+RWA", "上新"],
    riskTip:
      "【风险提示】本金库：买卖税进金库后，烧税币记权重再分奖励；领金库奖励会清零权重。规格里「销毁/分红/流动性 0%」是 Flap 税分账走税金库（通常 100% 进金库），不等于没有玩法。防农民主要限制乱加 V3 池，不等于锁仓不能卖。Mint 领取只是按份额转代币，本身无额外锁仓。DYOR。",
    riskTipEn:
      "Risk: this vault burns tax tokens for weight then shares rewards; claiming vault rewards resets weight. Specs showing burn/div/LP at 0% means Flap tax routing goes to the vault (often 100%), not “no mechanics”. Anti-farmer mainly blocks rogue V3 LPs — not a sell lock. Mint claim only transfers your share; no extra lock on claim. DYOR.",
    startupTax: true,
    deployNote:
      "要填：0 项\n\n粘贴工厂地址后，直接点确认即可。\n支付底可在 CRYPTO（BNB / ETH / USDT 等）或 RWA（股票底/黄金等）中任选。\n发射后约 1 分钟税会先走开发者地址（正常现象）。",
    deployNoteEn: "Fill: 0 fields\n\nPaste factory and confirm.\nQuote may be CRYPTO (BNB / ETH…) or RWA.\n~1 minute post-launch developer tax routing is expected.",
  },
  {
    id: "alpha-points",
    category: "build",
    isNew: true,
    name: "阿尔法积分工厂",
    nameEn: "Alpha Points Factory",
    summary:
      "阿尔法积分金库：以 BNB 为底、SnowPair 为流通代币。买卖差异化价差（买 97%+2% 运营 / 卖 102%）；税路 40% 积分 · 50% 加池 · 9.9% 销毁 · 0.1% 裂变。约 0.1% 流通量 = 1 积分，支持烧分领底池。",
    summaryEn: "Alpha points vault: BNB quote, SnowPair as circulating token. Asymmetric spread (buy 97%+2% ops / sell 102%); tax 40% points · 50% add liquidity · 9.9% burn · 0.1% fission. ~0.1% supply = 1 point; burn points to claim quote pool.",
    factory: "0x29E3fe047DeE221E538989853c973DeDBe68e8e1",
    tokenCA: "0xe9e1ee57922022e7d2d614ed0d18912126777777",
    tokenLabel: "$CA",
    tokenName: "蝴蝶alpha",
    tokenSymbol: "蝴蝶alpha",
    image:
      "https://flap.mypinata.cloud/ipfs/bafybeibt2knspil2hhg25slsufdcwdmkayaesgdmwldjs7qp7prl7jtfhe",
    vaultImage: "/images/build-vault-aster.webp",
    flapUrl: "https://flap.sh/bnb/0xe9e1ee57922022e7d2d614ed0d18912126777777",
    tags: ["积分", "差异化价差", "烧分领池", "BNB底", "上新"],
    deployNote:
      "要填：1 项\n\n① 运营钱包\n填收 2% 运营税的钱包地址。\n不要填全是 0 的空地址。",
    deployNoteEn: "Fill: 1 field\n\n① Ops wallet for the 2% ops tax.\nDo not use the zero address.",
  },
  {
    id: "bbb-buyback",
    category: "flex",
    isNew: true,
    name: "全底池支付代币金额回购金库",
    nameEn: "Multi-quote amount buyback vault",
    summary:
      "bbb-v1（VaultBaseV3）：税路固定 98% 回购 · 1% 作者 · 1% 裂变。填回购间隔（秒，默认 60）与每次消耗（报价币单位，默认 0.1）；支持 BNB / ETH 等 CRYPTO 与股票底/黄金等官方 quote（全底池）。",
    summaryEn:
      "bbb-v1 (VaultBaseV3): fixed 98% buyback · 1% author · 1% fission. Set interval (sec, default 60) and spend per run in quote units (default 0.1); BNB/ETH crypto or stock/gold official quotes (multi-quote).",
    factory: "0x201385C8bd0Bf6445147e343EAF8B7B925bB4029",
    tokenCA: "0x86c2bb9fd97eca143de753b055152ffda3357777",
    tokenLabel: "$CA",
    tokenName: "特斯拉（无人出租车）",
    tokenSymbol: "Cybercab",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreiel63gnykrmvphlkpewfvrmqj6bfkxkx7hgxdp23ek7febu2yzklm",
    vaultImage: "/images/minute-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0x86c2bb9fd97eca143de753b055152ffda3357777",
    tags: ["全底池", "bbb-v1", "98%回购", "CRYPTO+RWA", "上新"],
    startupTax: true,
    deployNote:
      "要填：2 项（顺序别反）\n\n① 回购间隔\n单位是「秒」。默认 60。\n\n② 每次消耗\n按报价币填人类可读数量（18 位精度）。推荐 0.1；范围 0.001–1。\n\n支付底可在 CRYPTO（BNB / ETH / USDT 等）或 RWA（股票底/黄金等）中任选。\n发射后约 1 分钟税会先走开发者地址（正常现象）。",
    deployNoteEn:
      "Fill: 2 fields (order matters)\n\n① Interval in seconds (default 60)\n② Spend per run in quote units (18 decimals). Recommend 0.1; range 0.001–1.\n\nQuote may be CRYPTO (BNB / ETH…) or RWA.\n~1 minute post-launch developer tax routing is expected.",
  },
  {
    id: "x314-prize-pool",
    category: "buyback",
    isNew: true,
    name: "X314接龙奖池金库",
    nameEn: "X314 Solitaire Prize Pool",
    summary:
      "X314 接龙奖池金库 · BNB 底池。链上无需 vaultData；粘贴工厂地址后直接确认即可发射。",
    summaryEn:
      "X314 solitaire prize-pool vault · BNB quote. No vaultData on-chain; paste factory and confirm to launch.",
    factory: "0x51d551dEDdDE678dd61330269001824c7Bb822aB",
    tokenCA: "0xc9df75a64bfe9b7d133a6b88c91e8988e47c7777",
    tokenLabel: "$CA",
    tokenName: "最后一股",
    tokenSymbol: "最后一股",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreig32v6zkrycnumivb3agjgrn3vn2ouka6iyrprylzpi5zxfzbbg5i",
    vaultImage: "/images/minute-buyback-vault.webp",
    flapUrl: "https://flap.sh/bnb/0xc9df75a64bfe9b7d133a6b88c91e8988e47c7777",
    tags: ["BNB底", "X314", "接龙奖池", "上新"],
    startupTax: true,
    deployNote:
      "要填：0 项\n\n粘贴工厂地址后，直接点确认即可。\n仅支持 BNB 底池。\n发射后约 1 分钟，税会先走开发者地址（正常现象）。",
    deployNoteEn:
      "Fill: 0 fields\n\nPaste the factory and confirm.\nBNB quote only.\nFor ~1 minute after launch, tax may route to the developer address (expected).",
  },
  {
    id: "tmlp-multi-stock-lp",
    category: "flex",
    isNew: true,
    name: "沉锚 · Sink Anchor · 全底池",
    nameEn: "Sink Anchor · Multi-Quote · tmlp-v1",
    summary:
      "【Sink Anchor / 沉锚 · 全底池】税进金库后 100% 与所选锚 TOKEN 加池再毁 LP。自选 1～20 个锚（币股 / CRYPTO / 阿尔法 / Meme）；Registry 白名单（种子+蝴蝶 V2BNB>3）免检，其它须 Pancake V2 BNB 单边 > 3。支付底支持 CRYPTO 与 RWA 官方 quote。",
    summaryEn:
      "Sink Anchor · Multi-Quote: tax sinks into LP with your anchors, then LP burns. Pick 1–20 (stocks / CRYPTO / Alpha / Meme); Registry allowlist (seed + V2BNB>3) exempt, else V2 > 3 BNB. Quote: CRYPTO or RWA official quotes.",
    factory: "0x3E87EE15BA49eE9564591ea4d8DF77C2B72586c3",
    tokenCA: "0x7997a69c22fb4e0e76bffe0e809c172c32e87777",
    tokenLabel: "$CA",
    tokenName: "Taraxacum",
    tokenSymbol: "Taraxacum",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreifjyoksi7p3fo6w75thejkceh6hujg2klfiynukrpbx4hlsrqnuey",
    vaultImage: "/images/stock-percent-buyback-vault.png",
    flapUrl: "https://flap.sh/bnb/0x7997a69c22fb4e0e76bffe0e809c172c32e87777",
    tags: ["全底池", "Sink Anchor", "沉锚", "tmlp-v1", "CRYPTO+RWA", "上新"],
    startupTax: true,
    riskTip:
      "【池子风险】非 Registry 白名单锚须有 Pancake V2 BNB 对且 BNB 单边 > 3 BNB。池太薄会造成严重滑点，或加池/毁 LP 失败。流动性不足不是金库故障，请换更深标的或联系加白。DYOR。",
    riskTipEn:
      "Pool risk — Non-allowlisted anchors need Pancake V2 with > 3 BNB one side. Thin pools → severe slippage or failed legs. Thin liquidity is not a vault bug; ask for whitelist or DYOR.",
    deployNote:
      "Sink Anchor / 沉锚 · 全底池：任选 1～20 个锚（币股 / CRYPTO / 阿尔法 / Meme）。\n\n【风险】Registry 白名单（种子 RWA20 + 蝴蝶 V2BNB>3）免检；其它须 V2 BNB > 3。\n未用槽位填零地址（站内自动补）。\n\n支付底可在 CRYPTO 或 RWA 中任选。\n公开建池 ≈0.002 BNB；Trigger 毁 LP 每路 ≈0.01 BNB。",
    deployNoteEn:
      "Sink Anchor · Multi-Quote: pick 1–20 anchors (stocks / CRYPTO / Alpha / Meme).\n\nRegistry allowlist (seed RWA20 + butterfly V2BNB>3) exempt; others need V2 > 3 BNB.\nUnused slots = zero address.\n\nQuote may be CRYPTO or RWA.\nPublic seed ~0.002 BNB; burn-lane ~0.01 BNB per leg.",
  },
  {
    id: "rgalpha-v1",
    category: "build",
    isNew: true,
    name: "阿尔法双档锁仓 · Rgalpha",
    nameEn: "Rgalpha Dual-Cliff Alpha",
    summary:
      "Rgalpha-v1：BNB 底 · 双档 PinkLock 悬崖（7 天 15% / 30 天 35%）· VaultPair 买 95%+3%。税路含裂变 0.1% · 买入领取 · 加池种子 · 销毁 · 溢价 110% · 运营 9.9%；交易积分可兑库存。vaultData 仅填运营钱包。",
    summaryEn:
      "Rgalpha-v1: BNB quote · dual PinkLock cliffs (15% @7d / 35% @30d) · VaultPair buy 95%+3%. Tax path includes 0.1% fission · buyClaim · pairSeed · burn · 110% premium · 9.9% ops; trade points redeem inventory. vaultData = ops wallet only.",
    factory: "0x687274A8b0e914F44dA602a0BD60234F94cE300E",
    tokenCA: "0x852c51d8e36e6859993f5354779892e2c5607777",
    tokenLabel: "$CA",
    tokenName: "AURELIS",
    tokenSymbol: "AURX",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreido75h3azgejsooq3i6fisogllhq72usnuklh2tgv3eakw6kyl2qe",
    vaultImage: "/images/build-vault-aster.webp",
    flapUrl: "https://flap.sh/bnb/0x852c51d8e36e6859993f5354779892e2c5607777",
    tags: ["积分", "双档锁仓", "Rgalpha-v1", "BNB底", "上新"],
    startupTax: true,
    deployNote:
      "要填：1 项\n\n① 运营钱包\n填收 9.9% 运营税的钱包地址。\n不要填全是 0 的空地址。\n\n仅支持 BNB 底池。",
    deployNoteEn:
      "Fill: 1 field\n\n① Ops wallet for the 9.9% ops tax.\nDo not use the zero address.\n\nBNB quote only.",
  },
  {
    id: "fly-head-v1",
    category: "flex",
    isNew: true,
    name: "苍蝇头神经网络 · fly-v1",
    nameEn: "Fly Head Neural Network · fly-v1",
    summary:
      "【苍蝇头神经网络 fly-v1】全底池（BNB/任意 ERC20）；税 100% 果园；AI 决策 + Trigger 执行；买入按 BNB 价值 0.2～2；mate 毁 LP。填：本能门槛 · 吃饭 bps · 交配 bps · AI 冷却秒。夹紧不 revert。",
    summaryEn:
      "Fly Head Neural Network fly-v1: any quote (BNB/ERC20); 100% tax orchard; AI + Trigger; buy by BNB value 0.2–2; mate burns LP. Params: minActQuote · eatBps · mateBps · cooldown. Sandwich does not revert.",
    factory: "0xDa2eEfb06304857661712c163546Ef9f33C9f8F5",
    tokenCA: "",
    tokenLabel: "$CA",
    tokenName: "",
    tokenSymbol: "",
    image:
      "https://flap.mypinata.cloud/ipfs/bafkreie2klmdqwwvownoyuawqgfvh4xywnhgzydx5hrargivdjaod33gtu",
    vaultImage: "/images/build-vault-aster.webp",
    flapUrl: "",
    tags: ["苍蝇头", "fly-v1", "全底池", "AI", "上新"],
    startupTax: true,
    deployNote:
      "要填：4 项（顺序别反）\n\n① 本能门槛 minActQuote\n报价币人类可读数量（18 位）。默认 0.01。\n\n② 吃饭 bps eatBps\n1000～7000，默认 3000。\n\n③ 交配 bps mateBps\n2000～8000，默认 5000。\n\n④ AI 冷却秒 cooldownSeconds\n600～21600（10 分钟～6 小时），默认 1800（30 分钟）。\n\n支付底：BNB 或任意 ERC20。",
    deployNoteEn:
      "Fill: 4 fields (order matters)\n\n① minActQuote — quote human amount (18 decimals). Default 0.01.\n② eatBps — 1000–7000, default 3000.\n③ mateBps — 2000–8000, default 5000.\n④ cooldownSeconds — 600–21600 (10m–6h), default 1800.\n\nQuote: BNB or any ERC20.",
  },
];
export default FLAP_VAULTS;
